<template>
  <div v-cloak class="catalogue conten bg-white">
    <p class="padding0-15 ft16 gray-2 titleBox">{{ courseTitle }}</p>
    <chapter-list :catalogueData="catalogueData" :isJump="true" :gid="gid"></chapter-list>
    <Gohome @click="goHome"></Gohome>
  </div>
</template>

<script>
import ChapterList from "@/components/list/chapterList";
import { getCourseCatalog } from "@/model/learn/learnServer";
import Gohome from "@/components/gohome/gohome";
export default {
  name: "catalogue",
  data() {
    return {
      catalogueData: [],
      courseTitle: "",
      gid:0
    };
  },
  components: {
    ChapterList,
    Gohome,
  },
  created() {
    getCourseCatalog({ cid: this.$route.query.cid }).then((res) => {
      let data = res.data;
      this.courseTitle = data.course.courseTitle;
      this.catalogueData = data.glist
      this.gid = data.course.gid
    });
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.titleBox {
  height: 2.5rem;
  line-height: 2.5rem;
}
</style>
